import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/scss/reset.scss";
import "./styles/scss/common.scss";
import "./styles/scss/metaAds.scss";
import "@fortawesome/fontawesome-pro/css/all.min.css";
// import "./styles/management.css";
// import "./styles/website.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./contexts/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
